import * as z from "zod";

export const ShipmentExportRowType = {
  SHIPMENT: "shipment",
  SHIPMENT_PRODUCT: "shipment_product",
} as const;

export const exportShipments = {
  name: "exportShipments" as const,
  input: z
    .object({
      rowType: z.enum([
        ShipmentExportRowType.SHIPMENT,
        ShipmentExportRowType.SHIPMENT_PRODUCT,
      ]),
      startDate: z.string().date(),
      endDate: z.string().date(),
    })
    .refine(({ startDate, endDate }) => startDate <= endDate, {
      message: "Start date must be on or before end date",
      path: ["endDate"],
    }),
  output: z.object({ csv: z.string() }),
};
